const navbar3 = (editor) => {

    editor.BlockManager.add('navbar3', {
        category: 'Headers & Footers',
        label: ` 
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="1.4rem" height="1.4rem" viewBox="0 0 128.000000 128.000000"
                preserveAspectRatio="xMidYMid meet">
            
            <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path class="gjs-block-svg-path" 
            d="M223 1139 c-43 -13 -80 -60 -88 -112 -3 -23 -5 -213 -3 -422 3 -418
            2 -411 65 -452 25 -16 63 -18 443 -18 380 0 418 2 443 18 63 41 62 30 62 487
            0 380 -2 418 -18 443 -41 63 -32 62 -472 64 -226 1 -414 -2 -432 -8z m227
            -499 l0 -450 -107 0 c-96 0 -109 2 -130 22 l-23 21 0 406 c0 492 -14 451 152
            451 l108 0 0 -450z m617 428 l23 -21 0 -406 c0 -402 0 -405 -22 -428 -21 -23
            -22 -23 -290 -23 l-268 0 0 450 0 450 267 0 c260 0 267 -1 290 -22z"/>
            <path class="gjs-block-svg-path" 
            d="M253 983 c-18 -7 -16 -40 3 -47 9 -3 37 -6 64 -6 27 0 55 3 64 6 21
            8 21 40 0 48 -18 7 -113 7 -131 -1z"/>
            <path class="gjs-block-svg-path"  
            d="M253 823 c-18 -7 -16 -40 3 -47 32 -12 121 -6 134 9 23 27 -5 45 -69
            44 -31 0 -62 -3 -68 -6z"/>
            <path class="gjs-block-svg-path" 
            d="M253 663 c-18 -7 -16 -40 3 -47 32 -12 121 -6 134 9 23 27 -5 45 -69
            44 -31 0 -62 -3 -68 -6z"/>
            </g>
            </svg>
            <div class='gjs-fontFamily gjs-block-label'>Sidebar Header</div>`,
        attributes: {},
        content: `
        <nav class="navbar navbar-expand-sm navbar-light py-3 fs-3">
            <div class="container-fluid">
                <button
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#sidebar"
                    aria-controls="sidebar"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div
                    classtype='sidebar-container'
                    class="offcanvas offcanvas-start sidebar-container text-white"
                    id="sidebar"
                >
                    <div
                        class="offcanvas-header"
                        class="text-white fs-1"
                    >
                        <button
                            type="button"
                            class="text-white bg-transparent border-0 fs-1"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ><i class="bi-x text-white"></i></button>
                    </div>

                    <div class="offcanvas-body p-0">
                        <ul class="navbar-nav flex-column text-white h-100 py-5 ">
                            <li statype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Overview</span>
                                <i class="bi bi-house mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>List of Patients</span>
                                <i class="bi bi-people-fill mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Calendar</span>
                                <i class="bi bi-calendar-fill mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Notifications</span>
                                <i class="bi bi-bell-fill mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Messages</span>
                                <i class="bi bi-envelope-fill mx-5"></i>
                            </a>
                            </li>
                            <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                            <a class="d-flex align-items-center justify-content-end text-white">
                                <span>Preferences</span>
                                <i class="bi bi-gear-fill mx-5"></i>
                            </a>
                            </li>
                                
                        </ul>
                    </div>

                    <div class="offcanvas-footer">
                        <a class="d-flex align-items-center justify-content-end nav-link text-white pb-5" href="#!">
                            <span>Logout</span>
                            <i class="bi bi-box-arrow-right mx-5"></i>
                            </a>
                    </div>
                </div>
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav me-auto d-flex align-items-center justify-content-center">
                        <li
                            class="nav-item fs-1"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#sidebar"
                            aria-controls="sidebar"
                        >
                            <a
                                ><i classtype='text-green' class="bi bi-list text-green"></i
                            ></a>
                        </li>
                        <li class="nav-item nav-link" href="#!">
                            <a><i
                                    classtype='text-gray'
                                    class="bi bi-people text-gray"
                                ></i
                            ></a>
                        </li>
                    </ul>

                    <ul class="navbar-nav ms-auto  d-flex align-items-center justify-content-center">
                        <li class="nav-item nav-link" href="#!">
                            <a><i
                                    classtype='text-gray'
                                    class="bi bi-box-arrow-right text-gray"
                                ></i
                            ></a>
                        </li>
                        <li class="nav-item nav-link" href="#!">
                            <a><i
                                    classtype='text-gray'
                                    class="bi bi-gear-fill text-gray"
                                ></i
                            ></a>
                        </li>
                        <li class="nav-item nav-link pointer" href="#!">
                            <a class="position-relative"
                                ><i
                                    classtype='text-gray'
                                    class="bi bi-envelope-fill text-gray"
                                ></i
                            >
                            <span classtype="bg-green" class="position-absolute p-1 mt-2 ml-3 fs-6 top-0 start-50 translate-middle badge rounded-circle bg-green">
                                2 <!-- Number indicator -->
                                </span></a>
                        </li>
                        <li class="nav-item nav-link pointer" href="#!">
                            <a class="position-relative"
                                ><i
                                    classtype='text-gray'
                                    class="bi bi-bell-fill text-gray"
                                ></i
                            ><span classtype="bg-green" class="position-absolute p-1 mt-2 ml-3 fs-6 top-0 start-50 translate-middle badge rounded-circle bg-green">
                                4 <!-- Number indicator -->
                                </span></a>
                        </li>
                        <li classtype='text-green' class="nav-item nav-link pointer text-green" href="#!">
                            <p classtype='text-green' class="fw-bold text-green fs-5 my-auto"
                                >holoprac01</p
                            >
                        </li>
                        <li class="nav-item nav-link" href="#!">
                            <a>
                                <img
                                    src="https://i.ibb.co/7v05TmV/image.png"
                                    class="rounded-circle"
                                    alt="User Profile"
                                    width="50"
                                    height="50"
                                />
                            </a>
                        </li>
                        <li class="nav-item nav-link" href="#!">
                            <a class="navbar-brand"><img
                                    src="https://dummyimage.com/150x75/dee2e6/6c757d.jpg"
                                    alt="Logo"
                                    class="img-fluid"
                                    width="150"
                                    height="75"
                            /></a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        `
    })
};

export default navbar3;